
export default {
  name: 'MailUs',
  computed: {
    emailAddress() {
      return (
        {
          'parkos.be': 'support@parkos.nl',
          'parkos.de': 'support@parkos.de',
        }[this.$store.state.language.domain] || 'info@parkos.com'
      );
    },
  },
};
